import {registerHtmlHook} from "../utils/htmlHooks";

const toggleOnChange = ($, selector) => {
    const elements = typeof selector === 'undefined' ? $('[data-toggle="show-on-change"]') : $('[data-toggle="show-on-change"]', selector);

    elements.filter(':not(.binded)').each(function() {
        const me = $(this);
        me.addClass('binded');
        const value = me.data('value');
        const shouldDisableInputs = me.data('disable') === '';

        const input = $('[name="' + me.data('on') + '"]', selector || null);

        if (shouldDisableInputs) {
            if (me.hasClass('d-none')) {
                me.find('input, select, textarea').attr('disabled', 'disabled');
            } else {
                me.find('input, select, textarea').removeAttr('disabled');
            }
        }

        input.change(function() {
            console.log('ELEMENT:', this);
            console.log('ME:', me, $(this).val(), value);

            const el = $(this);

            let show = false;

            if (el.attr('type') === 'checkbox') {
                show = el.is(':checked') === !!value;
            } else if (Array.isArray(value)) {
                show = !!value.find(testValue => String($(this).val()) === String(testValue))
            } else {
                show = String($(this).val()) === String(value);
            }

            me.toggleClass('d-none', !show);

            console.log(show);

            if (shouldDisableInputs) {
                if(show) {
                    me.find('input, select, textarea').removeAttr('disabled');
                } else {
                    me.find('input, select, textarea').attr('disabled', 'disabled');
                }
            }
        });
    });
}

(function ($) {
    toggleOnChange($);
})(jQuery);

registerHtmlHook((container) => toggleOnChange($, container));

export {toggleOnChange};
